import React from 'react';
import { Sidebar } from '../components/home/Sidebar';
import { MobileHeader } from '../components/home/MobileHeader';
import { Hero } from '../components/home/Hero';
import { Principles } from '../components/home/Principles';
import { SelectedWork } from '../components/home/SelectedWork';
import { Writing } from '../components/home/Writing';
import { Playground } from '../components/home/Playground';
import { ContactCTA } from '../components/home/ContactCTA';
export function Home() {
  return <div className="min-h-screen w-full bg-canvas text-fg" data-id="element-864" data-mp="24g8u6n61ezh2">
      <MobileHeader data-id="element-865" data-mp="24ivb3detirby" />
      <div className="mx-auto flex max-w-[1200px] gap-14 px-5 md:px-8 lg:px-10" data-id="element-866" data-mp="29gdaod6y3u7a">
        <Sidebar data-id="element-867" data-mp="2dhqiutxig9hd" />
        <main className="min-w-0 max-w-[860px] flex-1 pb-12 pt-10 lg:pt-16" data-id="element-868" data-mp="2di8blgkys5kj">
          <Hero data-id="element-869" data-mp="2dfdunz15t2vv" />
          <Principles data-id="element-870" data-mp="3kvk3cdh3kp2t" />
          <SelectedWork data-id="element-871" data-mp="3ku8rrrheud15" />
          <Writing data-id="element-872" data-mp="3kv0nd2b0carf" />
          <Playground data-id="element-873" data-mp="3kxmtcxi92i7j" />
          <ContactCTA data-id="element-874" data-mp="3owlwqdoc26wv" />
          <footer className="mt-10 text-xs text-fg-faint" data-id="element-875" data-mp="3ovuc1xw9xtld">
            Designed with love <span aria-label="love" role="img" data-id="element-876" data-mp="30xb9s4x9izx9">♥️</span> by Kat Diaz - 2026
          </footer>
        </main>
      </div>
    </div>;
}